import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Spinner } from "reactstrap"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { debounce, map, range } from "lodash"
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
//actions
import { useLocation } from "react-router-dom/cjs/react-router-dom.min"

import {
  getStudents,
  //  deleteGroup
} from "store/actions"
//componets
import MyPagination from "components/Common/MyPagination"

//css
import "assets/scss/datatables.scss"

const InstituteStudents = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [searchText, setSearchText] = useState("")
  const [page, setPage] = useState(1)
  const limit = 10

  const { students, loading, language } = useSelector(state => ({
    students: state.Students.students,
    loading: state.Students.loading,
    language: state.Layout.language,
  }))

  const madrasaId = location?.search?.split("?madrasaid=")[1]

  //pages
  const totalPages = Math.ceil(students?.count / 10)
  const pages = range(1, totalPages + 1)

  const pageSend = () => {
    if (page >= pages.length) {
      return pages.length
    }
    if (page < 1) {
      return 1
    } else {
      return page
    }
  }

  useEffect(() => {
    dispatch(getStudents("", madrasaId, searchText, pageSend()))
  }, [dispatch, madrasaId, page, searchText])

  // const handleDelete = id => {
  //   dispatch(deleteGroup(id, history))
  // }

  const columns = [
    {
      dataField: "no",
      text: `${language === "mal" ? "നം." : "No."}`,
    },
    {
      dataField: "name",
      text: `${language === "mal" ? "പേര്" : "Name"}`,
      sort: true,
    },
    {
      dataField: "class",
      text: `${language === "mal" ? "ക്ലാസ്" : "Class"}`,
    },
    {
      dataField: "parent_name",
      text: `${language === "mal" ? "രക്ഷിതാവ്" : "Parent"}`,
    },
    {
      dataField: "parent_phone",
      text: `${language === "mal" ? "ഫോൺ നമ്പർ" : "Parent Phone"}`,
    },
    {
      dataField: "varisankya_amount",
      text: `${language === "mal" ? "വരിസംഗ്യ തുക" : "Varisankya Amount"}`,
    },
    {
      dataField: "varisankya_wallet",
      text: `${language === "mal" ? "ബാലൻസ്" : "Balance"}`,
    },
    {
      dataField: "action",
      text: `${language === "mal" ? "പ്രവർത്തനങ്ങൾ" : "Actions"}`,
    },
  ]

  const StudentsData = map(students?.results, (item, index) => ({
    ...item,
    key: index,
    no: (pageSend() - 1) * limit + index + 1,
    class: (
      <p>
        {item?.class_name} {item?.division_name}
      </p>
    ),
    action: (
      <div>
        <Link to={`/student/${item?.id}`} className="btn btn-success btn-sm">
          {language === "mal" ? "കാണുക" : "View"}
        </Link>
      </div>
    ),
  }))

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  // Select All Button operation
  const selectRow = {
    mode: "checkbox",
  }

  const debounceMeetingSearch = debounce(value => setSearchText(value), 600)

  // const handleSearch = e => {
  //   setSearchText(e.target.value)
  // }

  return (
    <React.Fragment>
      <Row>
        {/* <Row>
          <div className="col-md-6">
            <Link
              to={`/surveyuser/create`}
              type="submit"
              style={{ width: language === "mal" ? "200px" : "150px" }}
              className="w-md btn btn-success d-block"
            >
              {language === "mal" ? "+ പുതിയത് ചേർക്കുക" : "+ New SurveyUser"}
            </Link>
          </div>
        </Row> */}
        <Col className="col-12 mt-2">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="id"
                columns={columns}
                data={StudentsData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <Row className="mb-2">
                      <Col md="4">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <form
                              className="app-search d-lg-block"
                              onChange={e =>
                                debounceMeetingSearch(e.target.value)
                              }
                            >
                              <div className="position-relative">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder={
                                    language === "mal"
                                      ? "തിരയുക..."
                                      : "Search..."
                                  }
                                  defaultValue={searchText}
                                />
                                <span className="bx bx-search-alt" />
                              </div>
                            </form>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                selectRow={selectRow}
                                classes={"table align-middle table-wrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                              />
                            </div>
                          </Col>
                        </Row>
                        <MyPagination
                          totalPages={pages}
                          page={page}
                          setPage={setPage}
                        />
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default InstituteStudents

// AllStudents.propTypes = {
//   history: PropTypes.object,
// }
